export const paymentOptions = ({
  amount,
  currency,
  config = {},
  paymentIsRecurring,
}) => {
  const options = {
    paymentOptionPriority: ['card'],
  };

  if (config.paypal_enabled) {
    options.paymentOptionPriority.push('paypal');
    options.paypal = {
      flow: 'vault',
      amount,
      currency,
    };
  }

  if (config.paypal_credit_enabled) {
    options.paymentOptionPriority.push('paypalCredit');
    options.paypalCredit = {
      flow: 'vault',
      amount,
      currency,
    };
  }

  if (config.apple_pay_enabled && !paymentIsRecurring) {
    options.paymentOptionPriority.push('applePay');
    options.applePay = {
      displayName: 'Hivebrite',
      paymentRequest: {
        label: 'Localized Name',
        total: amount,
      },
    };
  }

  if (config.google_pay_enabled && !paymentIsRecurring) {
    options.paymentOptionPriority.push('googlePay');
    options.googlePay = {
      googlePayVersion: 2,
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPrice: amount,
        currencyCode: currency,
      },
    };
  }

  if (config.venmo_enabled && !paymentIsRecurring) {
    options.paymentOptionPriority.push('venmo');
    options.venmo = {
      allowNewBrowserTab: false,
    };
  }

  return options;
};
